import { type SelectedFileExtended } from '@common/types/file.type';
import { type EHorizontalPosition } from '@common/enums';

export enum EHandleOrientation {
    horizontal = 'horizontal',
    vertical = 'vertical',
}

export type BeforeAfterWidgetData = {
    beforeImage: SelectedFileExtended;
    afterImage: SelectedFileExtended;
    horizontalAlign: EHorizontalPosition;
    handleOrientation: EHandleOrientation;
    handleColor: string;
    handlePosition: number;
    maxWidth: number;
};
